import { keyBy } from 'lodash';
import { useUserSilosQuery } from '@/api/userSilos.generated';
import { addressToOrderAddress } from '@/utils/addressToOrderAddress';
import { CartDeliveryAddress } from '@agrantis/cart';

export type UserSilo = {
  id: number;
  addressID?: string | null;
  name: string;
  icon?: string | null;
  description: string;
  capacity: number;
  currentProduce: string;
  freeCapacity: number;
  retailerID?: string | null;
  address: CartDeliveryAddress | undefined;
};

export function useUserSilosAndAddresses({
  retailerId,
}: {
  retailerId: string;
}): {
  silos: UserSilo[];
  addresses: { id: number; address: CartDeliveryAddress }[];
  primaryAddress: { id: number; address: CartDeliveryAddress } | undefined;
} {
  const [{ data }] = useUserSilosQuery();

  const addresses =
    data?.currentUser?.addresses
      .filter((i) => !!i)
      .map((i) => ({
        id: parseInt(i.id),
        address: addressToOrderAddress(
          i,
          data?.currentUser?.givenName,
          data?.currentUser?.familyName,
        )!,
      })) ?? [];

  const addressesById = keyBy(addresses, (i) => i.id);

  const primaryAddress = data?.currentUser?.primaryAddressId
    ? addressesById[data!.currentUser!.primaryAddressId]
    : undefined;

  const silos = (data?.currentUser?.silos ?? [])
    .filter((i) => !i.retailerID || i.retailerID === retailerId)
    .map((i) => ({
      ...i,
      id: parseInt(i.id),
      address: i.addressID ? addressesById[i.addressID].address : undefined,
    }));
  return { silos, addresses, primaryAddress };
}
